import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { IoMdTime } from "react-icons/io";
import { GoPencil } from "react-icons/go";
import { FaAngleUp, FaAngleDown } from "react-icons/fa6";
import "./CustomTimePicker.css";

export default function DurationPicker({ value = { hours: 1, minutes: 0 }, onChange }) {
  const [open, setOpen] = useState(false);
  const [hours, setHours] = useState(value.hours || 1);
  const [minutes, setMinutes] = useState(value.minutes || 0);

  useEffect(() => {
    setHours(value.hours || 0);
    setMinutes(value.minutes || 0);
  }, [value]);

  const formatDisplay = () => `${hours}h ${minutes}m`;

  const increase = (type) => {
    if (type === "hour") setHours((prev) => (prev === 12 ? 0 : prev + 1));
    else if (type === "minute")
      setMinutes((prev) => (prev + 5 >= 60 ? 0 : prev + 5));
  };

  const decrease = (type) => {
    if (type === "hour") setHours((prev) => (prev === 0 ? 12 : prev - 1));
    else if (type === "minute")
      setMinutes((prev) => (prev - 5 < 0 ? 55 : prev - 5));
  };

  const handleSave = () => {
    onChange({ hours, minutes });
    setOpen(false);
  };

  return (
    <div className="appointment-page time-dropdown">
      <div
        className="appointment-page time-input"
        onClick={() => setOpen(!open)}
      >
        <span className="appointment-page icon-block-flex">
          <IoMdTime /> {formatDisplay()}
        </span>
        <span className="appointment-page edit-icon">
          <GoPencil />
        </span>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            className="appointment-page timepicker-popup"
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.2 }}
          >
            <div className="timepicker-grid">
              <div className="timepicker-column">
                <button onClick={() => increase("hour")}><FaAngleUp /></button>
                <span className="timepicker-font-weight">
                  {String(hours).padStart(2, "0")}
                </span>
                <button onClick={() => decrease("hour")}><FaAngleDown /></button>
              </div>

              <span className="colon">h</span>

              <div className="timepicker-column">
                <button onClick={() => increase("minute")}><FaAngleUp /></button>
                <span className="timepicker-font-weight">
                  {String(minutes).padStart(2, "0")}
                </span>
                <button onClick={() => decrease("minute")}><FaAngleDown /></button>
              </div>

              <span className="colon">m</span>
            </div>

            <div className="appointment-page time-buttons mt-3">
              <button
                className="appointment-page cancel"
                onClick={() => setOpen(false)}
              >
                Cancel
              </button>
              <button className="appointment-page save" onClick={handleSave}>
                Save
              </button>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}
